/* eslint-disable no-new */
import App from './App'
import HomeManager from './managers/HomeManager'

document.addEventListener('DOMContentLoaded', () => {
    new HomeManager()
    new App()
})
